import { createApi } from '@reduxjs/toolkit/query/react';
import { IApiResponse } from '../../interfaces/common';
import { baseQuery } from './common';
import { IHospital } from '../../interfaces/hospital';

export const hospitalApi = createApi({
	reducerPath: 'hospital',
	baseQuery: baseQuery,
	tagTypes: ['Hospital'],
	// refetchOnFocus: true,
	// refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getHospitalDetails: builder.query<IApiResponse<IHospital>, string>({
			query: (id) => `hospitals/${id}`,
			providesTags: (result, error, arg) => [{ type: 'Hospital', id: arg }],
		}),

		updateHospitalContact: builder.mutation<IApiResponse<IHospital>, { id: string; email: string; dialCode: string; phone: string }>({
			query: ({ id, email, dialCode, phone }) => ({
				url: `hospitals/contact`,
				method: 'PUT',
				body: {id, email, dialCode, phone },
			}),
			invalidatesTags: (result, error, arg) => [{ type: 'Hospital', id: arg.id }],
		}),	
		
	}),
});

export const { 
	useGetHospitalDetailsQuery,
	useUpdateHospitalContactMutation,
 } = hospitalApi;
